import Store from "../store/store";
import BaseEventTracker from "../../../shared/utils/EventTracker";

export default class EventTracker {
    constructor() {
        this.tracker = new BaseEventTracker();
    }

    play(music) {
        this.tracker.play({
            id: music.id,
            name: music.name,
            type: music.getType(),
            affiliation: this.getAffiliation()
        });
    }

    checkout() {
        const { items, total, coupon } = Store.state.cart.getSummary();

        this.tracker.checkout({
            total,
            coupon,
            items: items.map((item) => ({ ...item, affiliation: this.getAffiliation() }))
        });
    }

    addToCart(cartItem) {
        const { id, name, type, license } = Store.state.cart.getItemSummary(cartItem);
        this.tracker.addToCart({
              id,
              name,
              affiliation: this.getAffiliation(),
              license,
              type
          }
        );
    }

    applyCoupon(coupon) {
        this.tracker.applyCoupon(coupon.code);
    }

    socialShare(shareable, socialAccount) {
        this.tracker.share({
            id: shareable.id,
            name: shareable.name,
            type: shareable.type,
            socialAccount
        })
    }

    getAffiliation() {
        return Store.state.currentConfig.sales_tracking;
    }

    capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}